import { useEffect, useState } from 'react'
import { cloneDeep, orderBy, isEmpty, find, forEach, split, last, isNull, isUndefined } from 'lodash'
import { shallowEqual, useSelector } from 'react-redux'

const SORT_ELEM = ['asc', 'desc']

function UseTableSort(columns) {
	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	const [tableData, setTableData] = useState([])
	const [tableTranslate, setTableTranslate] = useState([])
	const [tableSorted, setTableSorted] = useState([])
	const [dataToSort, setDataToSort] = useState('')
	const [sortDirection, setSortDirection] = useState(0)
	const [forceUnsort, setForceUnsort] = useState(false)
	const [trigger, setTrigger] = useState({
		data: '',
		trigger: 0,
	})

	const handleSortDirection = () => {
		const idxIncrease = sortDirection + 1

		return idxIncrease >= SORT_ELEM.length ? 0 : idxIncrease
	}

	const handleChangeDataSorted = (column) => {
		setDataToSort(trigger.data)

		setSortDirection(0)

		// Ordering by lodash function
		let arr = orderBy(tableTranslate, [column.sortedBy || column.dataHook], [SORT_ELEM[0]])

		// Ordering string value with natural order
		setTableSorted(
			arr.slice().sort((a, b) => {
				// We only want to sort string here
				if (typeof a[column.sortedBy || column.dataHook] === 'string') {
					return a[column.sortedBy || column.dataHook].localeCompare(b[column.sortedBy || column.dataHook], undefined, { numeric: true })
				} else if (a[column.sortedBy || column.dataHook] === null) {
					// Also forcing sort of null elements between each other
					return -1
				}
			})
		)
	}

	const handleChangeSorted = (column) => {
		const idx = handleSortDirection()

		setSortDirection(idx)

		// Ordering by lodash function
		let arr = orderBy(tableTranslate, [column.sortedBy || column.dataHook], [SORT_ELEM[idx]])

		// Ordering string value with natural order
		idx === 1
			? setTableSorted(
					arr.slice().sort((a, b) => {
						// We only want to sort string here
						if (typeof b[column.sortedBy || column.dataHook] === 'string') {
							return b[column.sortedBy || column.dataHook].localeCompare(a[column.sortedBy || column.dataHook], undefined, {
								numeric: true,
							})
						} else if (b[column.sortedBy || column.dataHook] === null) {
							// Also forcing sort of null elements between each other
							return -1
						}
					})
			  )
			: setTableSorted(
					tableTranslate.slice().sort((a, b) => {
						// We only want to sort string here
						if (typeof a[column.sortedBy || column.dataHook] === 'string') {
							return a[column.sortedBy || column.dataHook].localeCompare(b[column.sortedBy || column.dataHook], undefined, {
								numeric: true,
							})
						} else if (a[column.sortedBy || column.dataHook] === null) {
							// Also forcing sort of null elements between each other
							return -1
						}
					})
			  )
	}

	useEffect(() => {
		const column = find(columns, { headerName: trigger.data, sortable: true })

		if (!column) {
			return
		}

		if (trigger.data !== dataToSort) {
			return handleChangeDataSorted(column)
		}

		if (!forceUnsort) handleChangeSorted(column)
	}, [trigger, tableTranslate, forceUnsort])

	useEffect(() => {
		const newData = cloneDeep(tableData)
		if (isEmpty(translations || isEmpty(columns))) {
			return
		}
		forEach(columns, (column) => {
			column.toTranslate &&
				forEach(newData, (row) => {
					const objectIterate = iterateObjectKey(column.dataHook, row) || null
					if (!isNull(objectIterate)) {
						const objectKeysEnd = split(column.dataHook, '.') || null
						// When we re-render table (by toggling nested for example), object got is already translated.
						// If we don't test the translation, it will try to translate again the object, which causing "-" displayed.
						// A simple test should suffice.
						if (!isUndefined(translations[objectIterate[last(objectKeysEnd)]])) {
							objectIterate[last(objectKeysEnd)] = translations[objectIterate[last(objectKeysEnd)]] || null
						}
					}
				})
		})
		setTableTranslate(newData)
		setTableSorted(newData)
		if (forceUnsort) {
			setForceUnsort(false)
		}
	}, [tableData, translations, forceUnsort])

	const iterateObjectKey = (objectKeys = '', object) => {
		let objectIterate = object
		const keyList = split(objectKeys, '.')

		forEach(keyList, (item, id) => {
			if (id === keyList.length - 1) {
				return objectIterate
			}
			objectIterate = objectIterate[item]
		})

		return objectIterate
	}

	return [tableSorted, trigger, setTrigger, setTableData, setForceUnsort]
}

export default UseTableSort
